export default __webpack_public_path__ + "static/media/flag-button-inactive@3x.b595be4d.png";